import React, { useState } from "react";
import { useQuery } from "@apollo/client";

import ModalContainer from "~/components/Modals/ModalContainer";
import TooltipTwo from "~/components/TooltipTwo";
import { Identifiers } from "~/constants/enum";
import { QUERY_GET_CMS_BLOCKS } from "~/data/home";

type Props = {};

const HowToVerifyWork = (props: Props) => {
  const [learmore, setLearnMore] = useState(false);

  const { data: cmsVeryfied } = useQuery(QUERY_GET_CMS_BLOCKS, {
    variables: {
      identifiers: [Identifiers.VeryfiedPurchase],
    },
    context: { fetchOptions: { method: "GET" } },
    notifyOnNetworkStatusChange: true,
  });

  return (
    <div>
      <span>
        <TooltipTwo id="learn-more" clickable title={<div className="flex w-[200px] flex-col whitespace-pre-wrap text-xs" >
          We automatically send review requests to customers who buy from
          our site.
          <a className="underline cursor-pointer" onClick={() => setLearnMore(true)}>
            Learn more
          </a>
        </div>}>
          <img src="/svgs/information.svg" width={24} height={24} />
        </TooltipTwo>
      </span>
      <ModalContainer
        title={cmsVeryfied?.cmsBlocks?.items?.[0]?.title || ""}
        open={learmore}
        onClose={() => setLearnMore(false)}
      >
        <div
          className="w-full p-2"
          dangerouslySetInnerHTML={{
            __html: cmsVeryfied?.cmsBlocks?.items?.[0]?.content,
          }}
        ></div>
      </ModalContainer>
    </div>
  );
};

export default HowToVerifyWork;
